"use client";

import { useState, useTransition } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { setCompanionSportRelationship } from "@/app/actions/companion-sport-profile";
import { COMPANION_RECOMMENDATION_SPORTS, type CompanionRecommendationSport } from "@/lib/companion/recommendation-types";
import { isSupProfileKey } from "@/lib/conditions/sport-profiles";
import { sportLabel } from "@/lib/conditions/sport-meta";
import { trackEvent } from "@/lib/analytics";

export function CompanionSportSetup({ knownSports, includeNamedSupProfiles = false }: {
  knownSports: CompanionRecommendationSport[];
  includeNamedSupProfiles?: boolean;
}) {
  const router = useRouter();
  const [sport, setSport] = useState<CompanionRecommendationSport>("surf");
  const [pending, startTransition] = useTransition();
  const [message, setMessage] = useState<string | null>(null);
  return (
    <form onSubmit={(event) => {
      event.preventDefault();
      setMessage(null);
      startTransition(async () => {
        try {
          await setCompanionSportRelationship({ sport, relationship: "known" });
          setMessage("Sport saved. Your recommendation is updating.");
          try { trackEvent("companion_sport_saved", { source: "setup" }); } catch { /* Saving must not depend on analytics. */ }
          router.refresh();
        } catch {
          setMessage("We could not save your sport. Please try again.");
        }
      });
    }} className="mt-3 space-y-3">
      {knownSports.length ? <p className="text-[12px] text-text-muted">Saved: {knownSports.map(sportLabel).join(", ")}</p> : null}
      <label className="block text-[12px] font-semibold text-navy">
        A sport you do
        <select value={sport} onChange={(event) => setSport(event.target.value as CompanionRecommendationSport)} className="mt-1 min-h-[44px] w-full rounded-sm border border-border-light bg-white px-2 text-[13px]">
          {COMPANION_RECOMMENDATION_SPORTS.filter((key) => key !== "sup" && (includeNamedSupProfiles || !isSupProfileKey(key))).map((key) => <option key={key} value={key}>{sportLabel(key)}</option>)}
        </select>
      </label>
      <button type="submit" disabled={pending} className="min-h-[44px] rounded-sm bg-teal px-3 py-2 text-[12px] font-semibold text-white hover:bg-teal-dark disabled:opacity-60">{pending ? "Saving…" : "Save sport"}</button>
      <Link className="inline-flex min-h-11 items-center text-xs font-semibold text-teal underline" href="/companion/you/activities">Set ability and manage activities</Link>
      {message ? <p role="status" className="text-[12px] text-navy">{message}</p> : null}
    </form>
  );
}
